import { Division, EntityType } from "../../../../../models";
import { EditCreateEntityActions } from "../../../../actions/EditCreateEntityActions";
import { ErrorActions } from "../../../../flux/Error/ErrorActions";
import { assertValue } from "../../../../utils/assert/index";
import { appNavigator } from "../../../../routes";

export class ShowEditDivisionCommand
{
    private editActions = new EditCreateEntityActions();
    private upsertErrorActions = new ErrorActions();
    
    constructor(private upsertErrorDispatchToken: string)
    {
    }
    
    execute = (toEdit: Division) => {
        assertValue(toEdit, 'division to edit couldn\'t be empty');
        this.editActions.setEntityToEdit(toEdit, EntityType.Division);
        this.upsertErrorActions.clearError(this.upsertErrorDispatchToken);
        appNavigator.goToEditEntityTab(EntityType.Division);
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Division/commands/ShowEditDivisionCommand.ts